import * as React from "react";

;
export const InactiveCheckboxUnchecked = (props: React.SVGProps<SVGSVGElement>) => <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect width={16} height={16} rx={4} fill="#CFCDD3" /></svg>;